<template>
 <v-card width="400px" class="mt-5 mx-auto" color="grey darken-3">
    <form class="signup-form" >
        <v-text-field
        :class="{amharic: am}"
        v-model="firstName"
        :label="$t('signUp.FIRSTNAME')"
        :counter="10"
        :error-messages="firstNameErrors"
        dark
        required
        @input="$v.firstName.$touch()"
        @blur="$v.firstName.$touch()"></v-text-field>
        <v-text-field
        :class="{amharic: am}"
        v-model="lastName"
        :label="$t('signUp.LASTNAME')"
        :counter="10"
        :error-messages="lastNameErrors"
        dark
        required
        @input="$v.lastName.$touch()"
        @blur="$v.lastName.$touch()"></v-text-field>
        <span 
        :class="{amharic: am}"
        v-if="smsFailed" 
        style="color: #FFC107; font-size:12px">
        <v-icon small color="amber">mdi-alert</v-icon>
        {{ $t('signIn.SMSFAILED') }}
        </span>
        <v-text-field
        :class="{amharic: am}"
        v-model="phone"
        :label="$t('signUp.PHONE')"
        :error-messages="phoneErrors"
        dark
        required
        @input="$v.phone.$touch()"
        @blur="$v.phone.$touch()"
        ></v-text-field>
        <v-text-field
        :class="{amharic: am}"
        v-model="email"
        :label="$t('signUp.EMAIL')"
        dark
        required
        :error-messages="emailErrors"
        @input="$v.email.$touch()"
        @blur="$v.email.$touch()"></v-text-field>
        <v-text-field
        :class="{amharic: am}"
        v-model="confirmEmail"
        :label="$t('signUp.CONFIRMEMAIL')"
        dark
        required
        :error-messages="confirmEmailErrors"
        @input="$v.confirmEmail.$touch()"
        @blur="$v.confirmEmail.$touch()"></v-text-field>
        <v-autocomplete
        :class="{amharic: am}"
        prepend-icon="mdi-city"
        v-model="city"
        :items="cities"
        :label="`City  ${ !isEditing ? 'Enter your city' : ''}`"
        :error-messages="cityErrors"
        dark
        required
        @click="isEditing = !isEditing"
        @input="$v.city.$touch()"
        @blur="$v.city.$touch()"></v-autocomplete>
        <v-checkbox
        :class="{amharic: am}"
        v-model="policyAgreement"
        :label="$t('signUp.POLICYAGREE')"
        dark
        required
        :error-messages="policyAgreementErrors"
        @input="$v.policyAgreement.$touch()"
        @blur="$v.policyAgreement.$touch()"></v-checkbox>
        <v-text-field
        :class="{amharic: am}" 
        v-if="showVerifyCode" 
        :label="$t('signIn.ENTERSMSCODE')"
        v-model="verifyCode"
        dark></v-text-field>
        <p v-if="verifyError" 
        style="color: red; font-size:12px">{{ $t('signIn.BADSMSCODE') }}</p>
        <span 
        :class="{amharic: am}"
        v-if="!$v.$invalid && !showVerifyCode" 
        style="color: #D500F9; font-size:12px">
        <v-icon small color="#D500F9">mdi-information-outline</v-icon>
            {{ $t('signUp.VERIFYHINT') }} 
        </span>
        <v-progress-linear
        v-if="!$v.$invalid && !showVerifyCode" 
        indeterminate
        rounded
        height="6"
        color="purple accent-3">
        </v-progress-linear>
        <span 
        :class="{amharic: am}"
        v-if="phoneExists" 
        style="color: lime; font-size:12px">
        <v-icon small color="amber">mdi-alert</v-icon>
        {{ $t('signUp.ACCOUNTEXISTS') }}
        </span>
    </form>
    <span 
    :class="{amharic: am}"
    v-if="routedNewUser && $v.$invalid" 
    style="color: #FFC107; font-size:12px">
    <v-icon small color="amber">mdi-alert</v-icon>
    {{ $t('signUp.ROUTEDSIGNUP') }}
    </span>
    <v-card-actions>
        <v-btn 
        :class="{amharic: am}"
        left 
        class="mr-4"
        v-if="!showVerifyCode" 
        id="sign-in-button" 
        type="submit" 
        v-on:submit.prevent="smsAuthenticate"
        :disabled="!formClear || phoneExists"
        @click="smsAuthenticate">{{ $t('signIn.VERIFY') }}</v-btn>
        <v-btn
        :class="{amharic: am}" 
        v-if="showVerifyCode" 
        @click="signIn" 
        class="mr-4"
        :disabled="!formClear || phoneExists">{{ $t('signUp.REGISTER') }}</v-btn>
        <v-btn  @click="clear" class="mx-2">{{ $t('signUp.CLEAR') }}</v-btn>
    </v-card-actions>
</v-card>
</template>

<script>
// import { required,maxLength,email,minLength,numeric } from 'vuelidate/lib/validators';
import { required,maxLength,email,minLength,sameAs } from 'vuelidate/lib/validators';
import { firebaseAuthMixins} from './mixins/firebaseAuth';
import { ethiopiaCities } from '../data/cities';
export default {
    mixins:[
        firebaseAuthMixins,
    ],
    data() {
        return {
            firstName: '',
            lastName: '',
            email: '',
            confirmEmail: '',
            city: '',
            policyAgreement: false,
            registrationData: {},
            isEditing: false,
        }
    },
    validations: {
        firstName: {
            required,
            maxLen: maxLength(10),
        },
        lastName: {
            required,
            maxLen: maxLength(10),
        },
        email: {
            required,
            email,
        },
        confirmEmail: {
            required,
            email,
            sameAs: sameAs('email'),
        },
        phone: {
            required,
            // numeric,
            minLen: minLength(12),
            maxLen:maxLength(12),
        },
        city: {
            required,
        },
        policyAgreement: {
            checked (val) {
                return val
            },
        },

    },
    methods: {
        smsAuthenticate() {
            this.$store.dispatch('auth/smsAuthenticate',this.phone)
        },
        signIn() {
            this.$store.dispatch('auth/signIn',this.verifyCode)
        },
        register() {
            const registeredAt = new Date().toString();
            // eslint-disable-next-line no-console
            // console.log('registration time: ',registeredAt, 'user exists : ',this.phoneExists)
            this.registrationData = {
                firstName: this.firstName,
                lastName: this.lastName,
                email: this.email,
                phone: this.phone,
                policyAgreement: this.policyAgreement,
                dateRegistered: registeredAt,
                city: this.city,
            }
            this.$store.dispatch('auth/signUpRouter',this.registrationData)
            // this.$store.dispatch('auth/signup', registerData)
        },
        clear() {
            this.firstName = ''
            this.lastName = ''
            this.email = ''
            this.phone = ''
            this.policyAgreement = false
            this.city = ''
        },
        
    },
    computed: {
        firstNameErrors() {
            const errors = []
            if (!this.$v.firstName.$dirty) return errors
            !this.$v.firstName.maxLen && errors.push(this.$t('signUp.NAMELENERROR'))
            !this.$v.firstName.required && errors.push(this.$t('signUp.NAMEREQERROR'))
            return errors
        },
        lastNameErrors() {
            const errors = []
            if (!this.$v.lastName.$dirty) return errors
            !this.$v.lastName.maxLen && errors.push(this.$t('signUp.NAMELENERROR'))
            !this.$v.lastName.required && errors.push(this.$t('signUp.NAMEREQERROR'))
            return errors
        },
        emailErrors() {
            const errors = []
            if (!this.$v.email.$dirty) return errors
            !this.$v.email.email && errors.push(this.$t('signUp.EMAILVALIDERROR'))
            !this.$v.email.required && errors.push(this.$t('signUp.EMAILREQERROR'))
            return errors
        },
        confirmEmailErrors() {
            const errors = []
            if (!this.$v.confirmEmail.$dirty) return errors
            !this.$v.confirmEmail.email && errors.push(this.$t('signUp.EMAILVALIDERROR'))
            !this.$v.confirmEmail.required && errors.push(this.$t('signUp.EMAILREQERROR'))
            !this.$v.confirmEmail.sameAs && errors.push(this.$t('signUp.EMAILMATCHERROR'))
            return errors
        },
        phoneErrors() {
            const errors = []
            if (!this.$v.phone.$dirty) return errors
            // !this.$v.phone.numeric && errors.push('Phone number can have only numerics')
            !this.$v.phone.required && errors.push(this.$t('signIn.PHONEREQERROR'))
            if (!this.$v.phone.minLen || !this.$v.phone.maxLen) errors.push(this.$t('signIn.PHONEDIGITSERROR'))
            return errors
        },
        policyAgreementErrors() {
            const errors = []
            if (!this.$v.policyAgreement.$dirty) return errors
            !this.$v.policyAgreement.checked && errors.push(this.$t('signUp.POLICYERROR'))
            return errors
        },
        cityErrors() {
            const errors = []
            if (!this.$v.city.$dirty) return errors
            !this.$v.city.required && errors.push(this.$t('signUp.CITYERROR'))
            return errors
        },
        formClear() {
            return this.$v.$invalid ? false : true
        },
        routedNewUser() {
            return this.$store.getters['auth/routedNewUser']
        },
        cities() {
            const cityList = []
            ethiopiaCities.forEach(element => {
                cityList.push(element.city)
            });
            return cityList
        },
        am() {
            // eslint-disable-next-line no-console
            // console.log("locale is :", this.$i18n.locale)
            return this.$i18n.locale === 'አማ' ? true : false 
        }
        
    },
    watch: {
        'user': function(){ 
            // this.debouncedPhoneLookup()
            this.register()
        } 
    },
}
</script>

<style scoped>
 .signup-form {
    width: 400px;
    margin: 30px auto;
    border: 1px solid #eee;
    padding: 20px;
    box-shadow: 0 2px 3px #ccc;
  }

</style> 